// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import store from "./store";
import router from './router'
import Fx from './fx/Fx';
import Installer from './config/installer';
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.config.productionTip = false;

global.Fx = Fx;

/* eslint-disable no-new */
Fx.$globalVue = new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>',
    data: {
        system:{
            title: '利弘昇进销存管理系统'
        }
    }
});



// WEBPACK FOOTER //
// ./src/main.js